import React from "react";

export default function PrivacyPolicy() {
  return (
    <main
      style={{
        padding: "20px",
        maxWidth: "800px",
        fontSize: "0.8rem",
        margin: " auto",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.6",
        backgroundColor: "white",
      }}
    >
      <header>
        <h1>Privacy and Policy</h1>
      </header>
      <article>
        <p>
          This privacy policy applies to the <strong>Aplikasi GME</strong>{" "}
          mobile application (hereafter referred to as the "Application")
          created by Putra Ganda Dewata (hereafter referred to as the "Service
          Provider") as a free service. This Application is intended for use "AS
          IS" by ATM maintenance operators working for companies that have
          signed a business contract with the Service Provider.
        </p>
        <hr />

        <section>
          <h2>Information Collection and Use</h2>
          <p>
            The Application collects information when you download and use it.
            This information may include:
          </p>
          <ul>
            <li>
              <strong>IP Address:</strong> Your device's Internet Protocol
              address.
            </li>
            <li>
              <strong>Usage Data:</strong> The pages you visit, the time and
              date of your visit, and the duration of your stay.
            </li>
            <li>
              <strong>Application Interaction:</strong> The time spent on the
              Application.
            </li>
            <li>
              <strong>Device Information:</strong> The operating system you use
              on your mobile device.
            </li>
          </ul>
          <p>
            The Application does not gather precise information about your
            mobile device's location. However, it collects your approximate
            location to provide:
          </p>
          <ul>
            <li>
              <strong>Geolocation Services:</strong> Personalized content,
              recommendations, and location-based services (Geofencing).
            </li>
            <li>
              <strong>Analytics and Improvements:</strong> Aggregated,
              anonymized data to analyze user behavior and improve the
              Application.
            </li>
            <li>
              <strong>Third-Party Services:</strong> Anonymized data
              transmission to external services for optimization.
            </li>
          </ul>
        </section>
        <hr />

        <section>
          <h2>Communication and Personal Information</h2>
          <p>
            The Service Provider may contact you with important updates,
            required notices, and marketing promotions using the data you
            provide. You might be asked to submit personally identifiable
            information, such as your email address (
            <a href="mailto:putraganda.dewata@gmail.com">
              putraganda.dewata@gmail.com
            </a>
            ), to enhance your experience with the Application.
          </p>
        </section>
        <hr />

        <section>
          <h2>Third Party Access</h2>
          <p>
            Only aggregated and anonymized data is transmitted to external
            services for improving the Application. The Service Provider may
            share your information under the following circumstances:
          </p>
          <ul>
            <li>
              As required by law (e.g., complying with a subpoena or similar
              legal process).
            </li>
            <li>
              When necessary to protect the rights, safety, or property of the
              Service Provider or others, or to investigate fraud.
            </li>
            <li>
              With trusted service providers who work on behalf of the Service
              Provider and adhere to confidentiality conditions.
            </li>
          </ul>
          <p>
            The Application uses third-party services that have their own
            privacy policies, including:
          </p>
          <ul>
            <li>Google Play Services</li>
            <li>Google Analytics for Firebase</li>
            <li>Firebase Crashlytics</li>
          </ul>
        </section>
        <hr />

        <section>
          <h2>Opt-Out Rights</h2>
          <p>
            You can stop all information collection by simply uninstalling the
            Application using your device's standard uninstall process or via
            your app marketplace.
          </p>
        </section>
        <hr />

        <section>
          <h2>Data Retention Policy</h2>
          <p>
            The Service Provider will retain your data for as long as you use
            the Application and for a reasonable period thereafter. To request
            deletion of your data, please contact us at{" "}
            <a href="mailto:putraganda.dewata@gmail.com">
              putraganda.dewata@gmail.com
            </a>
            .
          </p>
        </section>
        <hr />

        <section>
          <h2>Children</h2>
          <p>
            The Application is not designed for users under the age of 13, and
            the Service Provider does not knowingly collect personal information
            from children under 13. If personal data from a child under 13 is
            discovered, it will be deleted immediately. Parents or guardians who
            suspect such data collection should contact us at{" "}
            <a href="mailto:putraganda.dewata@gmail.com">
              putraganda.dewata@gmail.com
            </a>
            .
          </p>
        </section>
        <hr />

        <section>
          <h2>Security</h2>
          <p>
            The Service Provider is committed to safeguarding your information.
            Appropriate physical, electronic, and procedural safeguards are in
            place to protect the data we process and maintain.
          </p>
        </section>
        <hr />

        <section>
          <h2>Changes to this Privacy Policy</h2>
          <p>
            This Privacy Policy may be updated periodically. Any changes will be
            posted on this page. Continued use of the Application signifies your
            acceptance of the updated policy.
          </p>
        </section>
        <hr />

        <section>
          <h2>Your Consent</h2>
          <p>
            By using the Application, you consent to the collection and use of
            your information as described in this Privacy Policy.
          </p>
        </section>
        <hr />

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have any questions regarding privacy or this policy, please
            contact the Service Provider at{" "}
            <a href="mailto:putraganda.dewata@gmail.com">
              putraganda.dewata@gmail.com
            </a>
            .
          </p>
        </section>
        <hr />

        <p
          style={{
            textAlign: "center",
            fontStyle: "italic",
            marginTop: "20px",
          }}
        >
          This privacy policy is effective as of 2025-03-15.
        </p>
      </article>
    </main>
  );
}
